import { render, staticRenderFns } from "./CustomerPieChart.vue?vue&type=template&id=12aec375&scoped=true&"
import script from "./CustomerPieChart.vue?vue&type=script&lang=js&"
export * from "./CustomerPieChart.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPieChart.vue?vue&type=style&index=0&id=12aec375&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12aec375",
  null
  
)

export default component.exports